export default Object.freeze({
  'none': 0,
  'requested': 1,
  'accepted': 2,
  'rejected': 3
})
